var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.54 36.05a58.44 58.44 0 01-6-7.61 56.36 56.36 0 01-4.64-8.32A47.81 47.81 0 017 11.55a20.56 20.56 0 014.33-5.82 11.3 11.3 0 012.73 2.84 13.35 13.35 0 012.11 6.71l-.4.27q-2.73 1.82 3 10.36 5.54 8.28 8.26 6.46l.4-.27a15.8 15.8 0 015.16 4.71 19.34 19.34 0 011.81 3.41 20 20 0 01-7 1.78 46.1 46.1 0 01-6.86-5.95zm-5.47-28a13.35 13.35 0 00-2.85-2.91l.8-.53a4.2 4.2 0 013-1 4.94 4.94 0 012.52 2.29 8.16 8.16 0 011.75 4.78 4.63 4.63 0 01-2.37 3.43l-.69.46a13.21 13.21 0 00-2.16-6.52zm18.44 28.13a14.4 14.4 0 00-5.17-4.7l.84-.56q4-2.66 7.61 2.78a4.92 4.92 0 011.14 3.1 3.64 3.64 0 01-1.85 2.28l-.88.59a13.66 13.66 0 00-1.69-3.49z",
    fill: "#c01774"
  })));
}

export default SvgIconPhone;